<template>
    <div class="top_con">
        <el-button type="primary" @click="back" style="margin-top:20px;">返回上一页</el-button>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" max-height="580px">
            <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
            <el-table-column  prop="contractname"  label="合同名称" show-overflow-tooltip></el-table-column>
            <el-table-column  prop="equipmentnum"  label="设备编号"></el-table-column>
            <el-table-column prop="propertynum"  label="产权编号"></el-table-column>
            <el-table-column prop="belonger"  label="设备归属人"></el-table-column>
            <el-table-column prop="qytime"  label="设备启用时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tztime"  label="设备停滞时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="fytime"  label="设备复用时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tytime"  label="设备报停时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="tel"  label="设备租赁状态" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.status">已租赁</span>
                    <span v-else>未租赁</span>
                </template>
            </el-table-column>
            <el-table-column label="设备报告名称" show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-link type="primary"  @click="open_bg(scope.row.sid,scope.row.id,scope.row.upid)">设备检测报告</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="address"  label="操作" fixed="right" header-align="center" width="420">
                <template slot-scope="scope">
                    <el-link :underline="false" @click="look(1,scope.row.id)" style="margin-right:20px;">查看</el-link>
                    <div v-if="user.roleId==1" style="display:inline-block">
                        <el-link :underline="false" @click='jiechu(scope.row.id)'  style="margin-right:20px;" v-if="scope.row.status==1">解除租赁</el-link>
                        <el-link :underline="false" @click='add_bg(scope.row.sid,scope.row.id)'  style="margin-right:20px;">添加报告</el-link>
                        <el-link :underline="false" @click='tingzhi(1,scope.row.id)'  style="margin-right:20px;">停滞</el-link>
                        <el-link :underline="false" @click='tingzhi(2,scope.row.id)' style="margin-right:20px;">恢复启用</el-link>
                        <el-link :underline="false" @click='dels(scope.row.id)' type="danger" style="margin-right:20px;">删除</el-link>
                        <el-link :underline="false" @click='open_time(scope.row.id)'>停滞记录</el-link>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
        <div>
            <el-dialog :title="zp_tit" :visible.sync="dialogFormVisible" width="70%">
                <el-form :model="form"  label-width="100px">
                    <el-row :gutter="8">
                        <el-col :span="8">
                            <el-form-item label="合同名称"> 
                                <el-input v-model="form.contractname" placeholder="暂无" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="设备编号">
                                <el-input v-model="form.conservator" placeholder="暂无" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                         <el-col :span="8">
                            <el-form-item label="产权编号">
                                <el-input v-model="form.propertynum" placeholder="暂无" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                     <el-row :gutter="8">
                         <el-col :span="8">
                            <el-form-item label="设备归属人">
                                <el-input v-model="form.belonger" placeholder="暂无" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="设备启用时间">
                                <el-input v-model="form.qytime" placeholder="暂无" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="设备停滞时间">
                                <el-input v-model="form.tztime" placeholder="暂无" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                     </el-row>
                    <el-row :gutter="8">
                        <el-col :span="8">
                            <el-form-item label="设备复用时间">
                                <el-input v-model="form.fytime" placeholder="暂无" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="设备报停时间">
                                <el-input v-model="form.tytime" placeholder="暂无" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="设备单价">
                                <el-input v-model="form.price" placeholder="暂无" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                     </el-row>
                     <el-row :gutter="8">
                        <el-col :span="8">
                            <el-form-item label="人工单价">
                                <el-input v-model="form.rgprice" placeholder="暂无" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="设备进场费用">
                                <el-input v-model="form.jcfee" placeholder="暂无" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="设备出场费用">
                                <el-input v-model="form.ccfee" placeholder="暂无" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                     </el-row>
                </el-form>
            </el-dialog>
            <el-dialog title="解除租赁" :visible.sync="zulin" width="40%">
                <el-form   label-width="88px">
                    <el-form-item label="报停时间">
                        <el-date-picker  v-model="bttime" type="date" placeholder="选择时间" value-format="yyyy-MM-dd"> </el-date-picker>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align:center;">
                    <el-button type="primary" @click="Query_zl" >确认</el-button>
                    <el-button @click="zulin = false">取 消</el-button>
                </div>
             </el-dialog>
             <el-dialog title="添加报告" :visible.sync="bgstatus" width="50%">
                <el-form :model="formInline"  label-width="100px">
                    <el-row :gutter="8">
                        <el-col :span="10">
                            <el-form-item label="报告名称"> 
                                <el-input v-model="formInline.reportname" placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="报告类型">
                                <el-select v-model="formInline.typec" placeholder="请选择" style="margin-right:20px;" :disabled="tit_type==1?true:false">
                                    <el-option label="设备检测报告" value="1"></el-option>
                                    <el-option label="防坠器检测报告" value="2"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                         <el-col :span="10">
                            <el-form-item label="检测报告编号">
                                <el-input v-model="formInline.testingnum" placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="检测时间">
                                <el-date-picker  v-model="formInline.testingtime" type="date" placeholder="选择月" value-format="yyyy-MM-dd"> </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-col :span="10">
                        <el-form-item label="备注">
                            <el-input v-model="formInline.beizhu" placeholder="请输入" :disabled="tit_type==1?true:false"></el-input>
                        </el-form-item>
                    </el-col>
                </el-form>
                <div slot="footer" class="dialog-footer" >
                    <el-button type="primary" @click="Addbg" >确认添加</el-button>
                    <el-button @click="bgstatus = false">取 消</el-button>
                </div>
            </el-dialog>
            <el-dialog :title="tztit" :visible.sync="tingzhis" width="40%">
                <el-form  label-width="88px">
                    <el-form-item label="停滞时间" v-if="tz_type==1">
                        <el-date-picker  v-model="tingzhitime" type="date" placeholder="选择时间" value-format="yyyy-MM-dd"> </el-date-picker>
                    </el-form-item>
                    <el-form-item label="复用时间" v-if="tz_type==2">
                        <el-date-picker  v-model="tingzhitime" type="date" placeholder="选择时间" value-format="yyyy-MM-dd"> </el-date-picker>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align:center;">
                    <el-button type="primary" @click="Query_TZ" >确认</el-button>
                    <el-button @click="tingzhis = false">取 消</el-button>
                </div>
             </el-dialog>
             <el-dialog title="停滞记录" :visible.sync="look_time" width="40%">
                 <el-table ref="multipleTable" :data="look_t" tooltip-effect="dark" style="width:90%;margin:0 auto"  max-height="180px">
                     <el-table-column   label="停滞时间">
                          <template slot-scope="scope">
                              <span>{{scope.row.tztime}}</span>
                          </template>
                    </el-table-column>
                    <el-table-column   label="复用时间">
                        <template slot-scope="scope">
                            <span>{{scope.row.fytime}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column   label="操作">
                        <template slot-scope="scope">
                            <el-link :underline="false" @click="edit_list(scope.row,scope.row.id)" style="margin-right:20px;">修改</el-link>
                        </template>
                    </el-table-column>
                </el-table>
             </el-dialog>
            <el-dialog title="修改" :visible.sync="edittingzhis" width="40%">
                <el-form  label-width="88px">
                    <el-form-item label="停滞时间">
                        <el-date-picker  v-model="tingzhitime_s" type="date" placeholder="选择时间" value-format="yyyy-MM-dd"> </el-date-picker>
                    </el-form-item>
                    <el-form-item label="复用时间">
                        <el-date-picker  v-model="fuyongtime" type="date" placeholder="选择时间" value-format="yyyy-MM-dd"> </el-date-picker>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align:center;">
                    <el-button type="primary" @click="Query_TZ_s" >确认</el-button>
                    <el-button @click="edittingzhis = false">取 消</el-button>
                </div>
             </el-dialog>
        </div>
    </div>
</template>
<script>
import {zlnum,GetHTXq,zulin_over,add_BG,tingzhi_fu,tingzhi_del,look_fy_time,tingzhi_edit} from '@/utils/api'

export default {
    data(){
        return{
            user:{},
            formInline:{
                reportname:'',
                typec:'',
                testingtime:'',
                testingnum:'',
                beizhu:''
            },
            houseLis:[],
            dialogFormVisible:false,
            zulin:false,
            bgstatus:false,
            zp_tit:"添加仓库",
            tingzhis:false,
            edittingzhis:false,
            tztit:'停滞时间',
            tz_type:1,
            tit_type:0,
            form:{},
            formLabelWidth: '120px',
            value:10,
            total:12,
            multipleSelection:[],
            tableData: [],
            pageNum:1,
            zlid:'',
            bttime:'',
            sbid:'',
            tingzhitime:'',
            tingzhitime_s:'',
            fuyongtime:'',
            edit_id:'',
            tzid:'',
            idxn:'',
            listid:'',
            look_time:false,
            look_t:[]
        }
    },
    methods:{
        handleCurrentChange(val){
            this.pageNum=val;
            let param ={
                numPerPage:this.value,
                pageNum:val,
                id:this.zlid,
            }
            zlnum(param).then(res=>{
                this.total=res.total,
                this.tableData=res.list
            });
        },
        open_bg(sid,id,upid){
            this.$router.push({
                path:'/BaoGao',
                query:{
                    sid:sid,
                    id:id,
                    upid:upid
                }
            })
        },
        open_time(id){
            this.look_time=true
            this.tzid=id;
            look_fy_time({'id':id}).then(res=>{
                this.look_t=res;
            })
        },
        tingzhi(idx,id){
            this.sbid=id;
            this.idxn=idx;
            this.tztime='';
            if(idx==1){
                this.tztit="停滞时间";
                this.tz_type=1;
            }else if(idx==2){
                this.tztit="复用时间";
                this.tz_type=2;
            }
            this.tingzhis=true;
        },
        Query_TZ(){
            let param ={
                userId:this.user.uid,
                id:this.sbid,
                tztime:this.tingzhitime,
                n:this.idxn
            }
            tingzhi_fu(param).then(res=>{
                this.tingzhis=false;
                let param ={
                    numPerPage:this.value,
                    pageNum:this.pageNum,
                    id:this.zlid
                }
                zlnum(param).then(res=>{
                    this.total=res.total,
                    this.tableData=res.list
                });
            })
        },
        look(idx,id){
            this.dialogFormVisible=true
            if(idx==1){
                this.zp_tit="查看详情";
                this.tit_type=1;
            }
            GetHTXq({'id':id}).then(res=>{
                this.form=res;
            })
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        //解除
        jiechu(id){
            this.zulin=true;
            this.sbid=id;
        },
        Query_zl(){
            let param ={
                userId:this.user.uid,
                id:this.sbid,
                kytime:this.bttime
            }
            zulin_over(param).then(res=>{
                this.zulin=false;
                let param ={
                    numPerPage:this.value,
                    pageNum:this.pageNum,
                    id:this.zlid,
                }
                zlnum(param).then(res=>{
                    this.total=res.total,
                    this.tableData=res.list
                });
            })
        },
        //添加报告
        add_bg(sid,id){
            this.bgstatus=true;
            this.sbid=sid;
            this.listid=id;
        },
        Addbg(){
            let param ={
                userID:this.user.uid,
                sid:this.sbid,
                id:this.listid,
                formInline:this.formInline
            }
            add_BG(param).then(res=>{
               this.bgstatus=false
            });
        },
        dels(id){
            this.$confirm('确定删除该条, 是否继续?', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    let param ={
                        userId:this.user.uid,
                        id:id
                    }
                    tingzhi_del(param).then(res=>{
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        let param ={
                            numPerPage:this.value,
                            pageNum:this.pageNum,
                            id:this.zlid,
                        }
                        zlnum(param).then(res=>{
                            this.total=res.total,
                            this.tableData=res.list
                        });
                    });
               
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        back(){
            this.$router.push({
                path:'/Warehousing'
            })
        },
        //修改记录
        edit_list(row,id){
            this.tingzhitime_s=row.tztime
            this.fuyongtime=row.fytime
            this.edittingzhis=true;
            this.edit_id=id;
        },
        Query_TZ_s(){
            let param ={
                id:this.edit_id,
                tztime:this.tingzhitime_s,
                fytime:this.fuyongtime
            }
            tingzhi_edit(param).then(res=>{
               this.edittingzhis=false;
               look_fy_time({'id':this.tzid}).then(res=>{
                    this.look_t=res;
                })
            });
        }
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        this.zlid=this.$route.query.id
        let param ={
            numPerPage:this.value,
            pageNum:this.pageNum,
            id:this.zlid,
        }
        zlnum(param).then(res=>{
            this.total=res.total,
            this.tableData=res.list
        });
    },
}
</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Warehouse.vue